import React, { useState } from 'react';

import { DangerAlert } from '@magoosh/lib/alerts';
import { DangerButton, DefaultFilledButton, ResponsiveButtonGroup } from '@magoosh/lib/button';
import { PurchaseAgreement } from 'types/purchase_agreement';
import { bugsnagNotify } from 'utilities/bugsnag';

import * as api from '@test_prep/app/api';

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  purchaseAgreement: PurchaseAgreement;
  // When the student's access runs out, for a student deciding whether to keep it until then
  expiresOn: string | null;
}

const GENERIC_ERROR = "We couldn't cancel your plan. Please try again, or reach out to help@magoosh.com.";

const CancelPlan: React.FC<Props> = (props) => {
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onContinue = async () => {
    setError(null);
    setIsSubmitting(true);

    try {
      await api.cancelPurchaseAgreement(props.purchaseAgreement);
      props.onSuccess();
    } catch (exception) {
      setError(exception.errors?._error || GENERIC_ERROR);
      bugsnagNotify(exception);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column gap-m">
      {error && <DangerAlert>{error}</DangerAlert>}

      <div>
        You will not be charged for any future payments.
      </div>

      <div>
        {
          props.expiresOn ? (
            `You will still be able to access Magoosh until your current access period ends on ${props.expiresOn}.`
          ) : (
            'You will still be able to access Magoosh until your current access period ends'
          )
        }
      </div>

      <ResponsiveButtonGroup>
        <DangerButton onClick={onContinue} submitting={isSubmitting}>
          Cancel Plan
        </DangerButton>

        <DefaultFilledButton disabled={isSubmitting} onClick={props.onClose}>
          Keep Plan
        </DefaultFilledButton>
      </ResponsiveButtonGroup>
    </div>
  );
};

export default CancelPlan;
